import * as React from 'react';
import { Ref, forwardRef } from 'react';
const SvgFormatItalic = (_, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 16 16"
    height={_.height}
    width={_.width}
    className={_.className}
    role={_.role}
    aria-label={_.ariaLabel}
    aria-hidden={_.ariaHidden}
    ref={ref}
  >
    <path
      fill={_.color}
      d="M3.772 15h6.1q.348 0 .56-.196a.71.71 0 0 0 .222-.548.68.68 0 0 0-.212-.529q-.212-.196-.56-.196H7.72L10.066 2.47h2.162a.78.78 0 0 0 .55-.196.71.71 0 0 0 .222-.549.68.68 0 0 0-.212-.528.78.78 0 0 0-.55-.196h-6.13a.78.78 0 0 0-.55.196.68.68 0 0 0-.212.528q0 .344.212.549.222.196.56.196H8.28L5.934 13.532H3.763a.78.78 0 0 0-.55.195.68.68 0 0 0-.213.529q0 .342.212.548.222.195.56.196"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgFormatItalic);
export default ForwardRef;
